export const backgroundColors = [
  "#9250FF",
  "#4C70EF",
  "#82C8EF",
  "#65A7B5",
  "#8ADCA6",
  "#D77CF1",
  "#EBB800",
  "#DC74FF",
  "#D7561E",
  "#F288A0",
];
